<div class="report-page">
  <div class="report-page__header">
    <span class="report-page__title flex justify-start items-center text-black font-black uppercase">
      Solicitações de atendimento
    </span>

    <div class="filters-toolbar">
      <div class="filters-toolbar__field">
        <select
          class="w-full form-select form-select-lg text-white font-medium bg-blumine"
          aria-label=".form-select-lg"
          [formControl]="orderControl"
        >
          <option [ngValue]="null" selected>Ordenar</option>
          <option *ngFor="let order of listOrder" [ngValue]="order.value">{{ order.label }}</option>
        </select>
      </div>

      <div class="filters-toolbar__field filters-toolbar__field--date">
        <mat-form-field appearance="fill" class="date-range-filter">
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Busque por data" />
            <input matEndDate formControlName="end" placeholder="" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
        </mat-form-field>
      </div>

      <div class="filters-toolbar__field" *ngIf="canFilterByCompany">
        <select
          class="w-full form-select form-select-lg text-white font-medium bg-blumine"
          aria-label=".form-select-lg"
          [formControl]="companyControl"
        >
          <option [ngValue]="null">Todas empresas</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>
      </div>

      <div class="filters-toolbar__field filters-toolbar__field--search">
        <input
          [formControl]="acaoInput"
          type="text"
          class="form-input w-full"
          placeholder="Pesquise por Usuário, Motivo, Tipo ou Descrição"
        />
      </div>

      <div class="filters-toolbar__actions">
        <button
          (click)="getUnavailableRequestsReports()"
          title="Filtrar solicitações"
          class="filters-toolbar__action btn btn--secondary h-35"
        >
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="Filtrar" />
        </button>

        <button
          (click)="cleanFilter()"
          title="Limpar filtros"
          class="filters-toolbar__action btn btn--primary h-35 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="Limpar filtros" />
        </button>

        <button
          *isAllowed="[ERoleAdminString.Admin, 'request-reports.export']"
          class="filters-toolbar__action btn btn--primary h-35 bg-blumine"
          title="Download Excel solicitações de atendimento"
          (click)="downloadExcel()"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-unavailable-requests-reports
      [unavailableRequestsReports]="unavailableRequestsReports"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="getUnavailableRequestsReports()"
    >
    </app-list-unavailable-requests-reports>
  </div>

  <hr class="my-10" />
</div>
